export const Label = ({ children }) => (
  <span style={{ fontWeight: 400, marginRight: 4 }}>
    {children}
  </span>
);